import { getDb } from "./core";
import { META_VAULT_AUTOLOCK_KEY, type SyncCursorRow } from "./types";

export type VaultAutolockStored = { minutes: number | null };

export async function loadVaultAutolockMinutes(): Promise<number | null> {
  const db = await getDb();
  const row = (await db.get("meta", META_VAULT_AUTOLOCK_KEY)) as unknown as VaultAutolockStored | undefined;
  if (!row || typeof row !== "object" || !("minutes" in row)) return 5;
  const m = (row as VaultAutolockStored).minutes;
  if (m === null) return null;
  if (typeof m === "number" && Number.isFinite(m) && m > 0) return m;
  return 5;
}

export async function saveVaultAutolockMinutes(minutes: number | null): Promise<void> {
  const db = await getDb();
  await db.put("meta", { minutes } as unknown as SyncCursorRow, META_VAULT_AUTOLOCK_KEY);
}
